import storage from '../../storage';
import { Decimal } from '../../datastructures';
import { getConfigManager } from '../../config/getConfigManager';
import { PoolTransactionHistoryItem } from '../../interfaces/PoolTransactionHistoryItem';
import { walletAddressAtom } from '../wallet';
import { createAsyncAtom } from '../../lib/state';

const poolsTransactionHistoryAtom = createAsyncAtom<PoolTransactionHistoryItem[]>(
  async get => {
    const walletAddress = await get(walletAddressAtom);
    if (!walletAddress) {
      return [];
    }

    try {
      const data = await storage.getPoolTransactionHistory(walletAddress);
      if (!data) {
        return [];
      }

      return data.map((doc): PoolTransactionHistoryItem => {
        const poolPairConfig = getConfigManager().getPoolPairConfig(doc.tokenA, doc.tokenB);

        const tokenAAmount = new Decimal(BigInt(doc.tokenAAmount), poolPairConfig.tokenA.decimals);
        const tokenBAmount = new Decimal(BigInt(doc.tokenBAmount), poolPairConfig.tokenB.decimals);

        return {
          hash: doc.hash,
          account: doc.account,
          tokenAAmount: tokenAAmount,
          tokenBAmount: tokenBAmount,
          date: new Date(doc.timestamp * 1000),
          type: doc.type.toLowerCase(),
          poolPair: poolPairConfig,
        };
      });
    } catch (e) {
      console.error('poolTransactionHistory - Failed to get pool transaction history', e);
      return null;
    }
  },
  undefined,
  ['user-refresh'],
);
export default poolsTransactionHistoryAtom;
